import React from 'react'

function Footer() {
  return (
    <div className="footer-container div-margin">
        <footer> @2022 By Sebastian Amariei</footer>
    </div>
  )
}

export default Footer
